module.exports = __webpack_public_path__ + "static/media/cookie.828c1c0e.svg";